import React from 'react';

import { ReactComponent as IconClose } from 'imgs/svg-icons/IconClose.svg';
import { APP_TOOLTIP_ID } from 'js/config/consts';

import './FilterCheckbox.css';

interface FilterCheckboxProps {
  title: string;
  selected?: boolean;
  disabled?: boolean;
  disabledByVisualStyle?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const FilterCheckbox = ({
  title,
  selected = false,
  disabled = false,
  disabledByVisualStyle = false,
  onChange
}: FilterCheckboxProps) => {
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onChange(event as unknown as React.ChangeEvent<HTMLInputElement>);
    }
  };

  const tooltipAttributes = disabledByVisualStyle
    ? {
        'data-tip': "Remove this filter by changing the project's Visual Style",
        'data-for': `${APP_TOOLTIP_ID}`
      }
    : {};

  return (
    <>
      <label
        className={`FilterCheckbox${disabledByVisualStyle ? ' FilterCheckbox--disabledByVisualStyle' : ''}`}
        tabIndex={disabled ? -1 : 0}
        onKeyDown={handleKeyDown}
        {...tooltipAttributes}
      >
        {title}
        <input
          type="checkbox"
          className="FilterCheckbox__input"
          disabled={disabled}
          checked={selected}
          onChange={onChange}
        />
        <IconClose className="FilterCheckbox__icon" />
      </label>
    </>
  );
};

export default FilterCheckbox;
